export default __webpack_public_path__ + "static/media/mpk_1.5a719eb6.png";